<template>
  <div class="user-profile-container">
    <div class="image-cover">
      <div class="breadcrumb-profile">
        <el-breadcrumb separator-class="icon-bullet-icon">
          <el-breadcrumb-item :to="{ name: 'Home' }"><b>Home</b></el-breadcrumb-item>
          <el-breadcrumb-item>Mi cuenta</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="banner-container">
      <el-row
        class="banner-content">
        <el-col
          :xs="24"
          :sm="3"
          :md="3"
          :lg="3"
          :xl="3"
          :offset="1"
          class="col-image-profile">
          <div class="image-profile"/>
          <div>
            <el-dropdown
              class="option-profile-resposnive"
              trigger="click">
              <i class="el-icon-more"/>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click="closeSession()">Cerrar sesión</el-dropdown-item>
                <el-dropdown-item>Cambiar contraseña</el-dropdown-item>
                <el-dropdown-item>Eliminar cuenta</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-col>
        <el-col
          :xs="24"
          :sm="3"
          :md="3"
          :lg="3"
          :xl="3"
          class="hidden-sm-and-up name-user">
          <h1>{{ user.userName }}</h1>
          <h2>{{ user.name_user }}</h2>
        </el-col>
        <el-col
          :xs="24"
          :sm="19"
          :md="20"
          :lg="20"
          :xl="20"
          class="tabs-profile">
          <router-link
            :to="{name:'general'}"
            class="mt-tabs">
            <el-button
              :class="{active: isActiveOne}"
              @click="changeStateOne">
              General
            </el-button>
          </router-link>
          <router-link
            :to="{name:'purchases'}"
            class="mt-tabs">
            <el-button
              :class="{active: isActiveThree}"
              @click="changeStateThree">
              Mis compras
            </el-button>
          </router-link>
          <router-link
            :to="{name:'invoice'}"
            class="mt-tabs">
            <el-button
              :class="{active: isActiveTwo}"
              @click="changeStateTwo">
              Facturación
            </el-button>
          </router-link>
        </el-col>
      </el-row>
    </div>
    <div class="grid-container">
      <el-row
        :gutter="20"
        class="grid-content">
        <el-col
          :xs="24"
          :sm="6"
          :md="6"
          :lg="6"
          :xl="6"
          class="first-col  hidden-xs-only">
          <div class="user-info">
            <div class="icon-more">
              <el-dropdown
                trigger="click"
                class="option-profile">
                <i class="el-icon-more"/>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    style="border: 1px solid blue"
                    @click="closeSession">Cerrar sesión</el-dropdown-item>
                  <el-dropdown-item>Cambiar contraseña</el-dropdown-item>
                  <el-dropdown-item>Eliminar cuenta</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="name-user">
              <span @click="closeSession">Cerrar sesion</span>
              <h1>{{ user.userName }}</h1>
              <h2>{{ user.name_user }}</h2>
            </div>
            <div class="info-user-fav">
              <div class="icon">
                <img
                  :src="user.iconCategory"
                  alt="">
              </div>
              <div>
                <span><b>Categoría favorita</b></span><br>
                <span>{{ user.favCategory }}</span><br>
                <span>{{ user.numEvents }} eventos</span>
              </div>
            </div>
            <div class="info-user-fav">
              <div class="image">
                <img
                  :src="user.lastEventImg"
                  alt="">
              </div>
              <div>
                <span><b>Último evento</b></span><br>
                <span>{{ user.nameEvent }}</span><br>
              </div>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="24"
          :sm="18"
          :md="18"
          :lg="18"
          :xl="18"
          class="user-box">
          <slot/>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import auth from '@/services/auth.service'
export default {
  name: 'UserProfile',
  components: {
  },
  data () {
    return {
      isActiveOne: false,
      isActiveTwo: false,
      isActiveThree: false
    }
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    }
  },
  mounted () {
    if (this.$route.name === 'purchases') {
      this.isActiveThree = true
    }
    if (this.$route.name === 'general') {
      this.isActiveOne = true
    }
    if (this.$route.name === 'invoice') {
      this.isActiveTwo = true
    }
    if (this.$route.name === 'details') {
      this.isActiveThree = true
    }
    if (this.$route.name === 'addInvoice') {
      this.isActiveTwo = true
    }
  },
  methods: {
    changeStateOne () {
      this.isActiveOne = true
      this.isActiveTwo = false
      this.isActiveThree = false
    },
    changeStateTwo () {
      this.isActiveOne = false
      this.isActiveTwo = true
      this.isActiveThree = false
    },
    changeStateThree () {
      this.isActiveOne = false
      this.isActiveTwo = false
      this.isActiveThree = true
    },
    closeSession () {
      auth.logout()
      this.$router.push({name: 'Home'})
      /* auth.logout()
      this.$router.replace('/')
      this.$router.push({name: 'Home'}) */
    }
  }
}
</script>

<style lang="scss" scoped>

  .user-box{
    @media #{$Note} {
      padding: 0 !important;
    }
  }
  .user-profile-container{
    width: 100%;
    margin-top: 70px;
      @media #{$iPhoneLandscape} {
        margin-top: 50px;
    }
  }
  .image-cover{
    height: 300px;
    background-image: url("/static/images/cover-profile.png");
    background-size: cover;
    padding: 15px 0 0 30px;
    @media #{$iPhone} {
      height: 150px;
    }
    @media #{$iPhoneLandscape} {
      height: 150px;
    }
  }
.banner-container{
  height: 60px;
  @media #{$Elementxs} {
    height: auto !important;
  }
  .banner-content{
    width: 1280px;
    margin: 0 auto !important;
    position: relative;
    @media #{$Laptop} {
      width: 100%;
    }
    .tabs-profile{
      @media #{$Elementxs} {
        text-align: center;
      }
      @media #{$Note} {
       border-bottom: 1px solid #E3E6EA ;
      }
      .mt-tabs{
        button{
          height: 60px;
          border: none;
          padding: 0;
          width: 120px;
          @include font-primary(14px, semibold);
          color: $dove;
          border-radius: 0;
          @media #{$iPhone} {
            width: 112px;
          }
          &:hover{
            background-color: white;
            color: $roseHeader;
          }
          &:focus{
            background-color: white;
          }
        }
      }
    }
    .col-image-profile{
      height: 60px;
      min-width: 120px !important;
      padding: 0 !important;
      position: relative;
      @media #{$Elementxs} {
        margin: 0 !important;
      }
      .image-profile{
        background-image: url("/static/images/image-prpfile.png");
        background-size: cover;
        background-position: center;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border-radius: 50%;
        border: 4px solid white;
        height: 120px;
        width: 120px;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        margin: 0 auto;
        transition: all .3s ease-in-out;
      }
      .option-profile-resposnive{
        display: none;
        @media #{$Elementxs} {
          display: block;
          float: right;
          transform: rotate(90deg) !important;
          color: $roseHeader;
          margin-top: 20px;
          margin-right: 18px;
        }

      }
    }

  }
}
.grid-container{
  @media #{$Note} {
    padding: 0;
  }
  .grid-content{
    margin: 0 auto !important;
    @media #{$Laptop} {
      width: 100% !important;
    }
    @media #{$Note} {
      padding: 0;
    }
  }
}

  .el-row{
    margin: 0 !important;
  }
  .name-user{
    text-align: center;
    margin-bottom: 40px;
    @media #{$Elementxs} {
      margin-bottom: 0;
      margin-top: 35px;
    }
    h1{
      margin: 0;
      @include font-primary(24px, light);
      color: $carbon;
      @media #{$Elementxs} {
        @include font-primary(18px, light);
        margin-bottom: 10px;
      }
    }
    h2{
      margin: 0;
      @include font-primary(14px, light);
      color: #777777;
    }
    button{
      color: $roseHeader;
      @include font-primary(12px, semibold);
      text-decoration: underline;
    }
  }
  .user-info{
    background-color: white;
    width: 100%;
    padding: 14px 20px 20px 20px;
    margin-bottom: 10px;
    border-radius: 2px;
    .icon-more{
      text-align: right;
      margin-bottom: 23px;
      i{
        transform: rotate(90deg);
        color: $roseHeader;
        font-size: 18px;
      }
    }
    .info-user-fav{
      border-top: 1px solid #E3E6EA;
      padding: 15px 0;
      display: flex;
      align-items: center;
      .icon{
        width: 65px;
        text-align: center;
        img{
          width: 40px;
          height: 40px;
        }
      }
      .image{
        width: 65px;
        text-align: center;
        img{
          width: 80%;
          height: 40px;
        }
      }
    }
  }
  .reset-password{
    background-color: white;
    width: 100%;
    padding: 20px 30px;
    .btn-reset{
      background-color: $roseHeader;
      color: white;
      @include font-primary(12px, bold);
      border-radius: 3px;
      border: none;
      width: 100%;
      white-space: normal;
    }
    .btn-cancel-account{
      margin: 0;
      text-decoration: underline;
      @include font-primary(12px, semibold);
      color: $carbon;
    }
  }

.active{
  box-shadow: inset 0px -3px 0px 0px $roseHeader;
  transition: all .3s ease-in-out;
  color: $carbon !important;
}
  .profile-box{
    background-color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/user-profile/user-profile.vue